import React, { Component } from 'react';


export default class SkinComponent extends Component {

    constructor(props) {
        super(props);
        this.app = this.props.app;
        this.game = this.app.game;
        this.skinLibrary = this.game.library.skinLibrary;
        this.skinLibrary.skinComponent = this;
        this.account = this.app.state.authenticator.account;
        this.state = {
            css: null,
        }
    }

    setSkin = () => {
        let skinId = this.account.selected_skin;
        let skin = this.skinLibrary.skins[skinId];
        if (skin) {
            let css = skin.css;
            this.setState({css: css});
        }
    }

    render() {
        return <style>{this.state.css}</style>;
    }
}
